import React, { FC, useMemo } from 'react';
import { CourseCard } from 'src/common/components/CourseCard';
import { UserCoursesCard } from 'src/user/courses/components/UserCoursesCard';
import { UserCoursesCards } from 'src/user/courses/components/UserCoursesCards';
import { mapToCourseExcerpt, PastCourseListItem } from 'src/common/models/pastCourseListItem';
import { CourseType } from 'src/common/models/courseType';

export interface UserCoursesPastContentProps {
  items: PastCourseListItem[];
}

export const UserCoursesPastContent: FC<UserCoursesPastContentProps> = ({ items }) => {
  const courseExcerpts = useMemo(
    () =>
      items
        .map((pastCourse) => ({
          courseExcerpt: mapToCourseExcerpt(pastCourse),
          pastCourse,
        }))
        .map(({ pastCourse, courseExcerpt }) => {
          const recording =
            pastCourse.recordingStatus && pastCourse.recordingAvailableUntil
              ? {
                  status: pastCourse.recordingStatus,
                  availableUntil: pastCourse.recordingAvailableUntil,
                }
              : undefined;

          return (
            <UserCoursesCard
              key={
                pastCourse.courseType === CourseType.StandardCourse
                  ? `${pastCourse.id}-${pastCourse.eventId}`
                  : pastCourse.id
              }
            >
              <CourseCard
                largeMobileImage
                courseExcerpt={courseExcerpt}
                recording={recording}
                survey={{
                  status: pastCourse.surveyStatus,
                  availableUntil: pastCourse.surveyAvailableUntil,
                }}
              />
            </UserCoursesCard>
          );
        }),
    [items],
  );

  return <UserCoursesCards>{courseExcerpts}</UserCoursesCards>;
};
